import {createRouter,createWebHistory} from 'vue-router';
import Dashboard from './components/dashboard.vue';
import Citizens from './components/citizens.vue';
import Ward     from './components/ward.vue';
import Road     from './components/road.vue';
import Block    from './components/block.vue';
import Login from './components/auth/login.vue';
import NirmalSathai from './components/nirmalSathai.vue';



const routes = [
    {
        path     : '/',
        component: Dashboard,
        name     : "dashboard-page"
    },
    {
        path     : '/citizens',
        component: Citizens,
        name     : "citizens-page"
    },
    {
        path     : '/nirmal-sathi',
        component: NirmalSathai,
        name     : "nirmal-sathi"
    },
    {
        path     : '/ward',
        component: Ward,
        name     : "ward"
    },
    {
        path     : '/road',
        component: Road,
        name     : "road"
    },
    {
        path     : '/block',
        component: Block,
        name     : "block"
    },
    {
        path     : '/login',
        component: Login,
        name     : "login-page"
    },
]

export default createRouter({
    history: createWebHistory(),
    routes
});